import { NoddiIcon } from 'noddi-ui-common';
import { useState } from 'react';
import { Button } from '../../../base/button/button';

type Props = {
  id: string;
  value: number;
  onChange: (value: number) => void;
  autoFocus?: boolean;
};

export const DurationUnitStepper = ({ id, value, onChange, autoFocus }: Props) => {
  const [draft, setDraft] = useState<string | null>(null);
  const display = draft !== null ? draft : String(value);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const cleaned = e.target.value.replace(/[^\d]/g, '').slice(0, 4);
    setDraft(cleaned);
    const n = parseInt(cleaned, 10);
    onChange(isNaN(n) ? 0 : n);
  };

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    e.target.select();
  };

  const handleBlur = () => {
    setDraft(null);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'ArrowUp') {
      e.preventDefault();
      onChange(value + 1);
    } else if (e.key === 'ArrowDown') {
      e.preventDefault();
      onChange(Math.max(0, value - 1));
    } else if (e.key === 'Enter') {
      e.currentTarget.blur();
    }
  };

  return (
    <div className='flex h-8 items-center overflow-hidden rounded-md border border-input bg-white shadow-xs transition-colors focus-within:ring-1 focus-within:ring-ring'>
      <input
        id={id}
        // oxlint-disable-next-line jsx-a11y/no-autofocus -- forwards the picker's opt-in autoFocus prop to the underlying input; the stepper never decides on its own
        autoFocus={autoFocus}
        inputMode='numeric'
        autoComplete='off'
        value={display}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        className='h-full min-w-0 flex-1 bg-transparent px-3 text-sm font-medium tabular-nums outline-hidden'
      />
      <div className='flex h-full flex-col border-l border-input'>
        <Button
          type='button'
          variant='ghost'
          size='icon'
          className='h-1/2 w-5 rounded-none p-0'
          onClick={() => onChange(value + 1)}
          onMouseDown={(e) => e.preventDefault()}
          tabIndex={-1}
        >
          <NoddiIcon name='ChevronUp' size='xSmall' />
        </Button>
        <Button
          type='button'
          variant='ghost'
          size='icon'
          className='h-1/2 w-5 rounded-none border-t border-input p-0'
          onClick={() => onChange(Math.max(0, value - 1))}
          onMouseDown={(e) => e.preventDefault()}
          tabIndex={-1}
          disabled={value === 0}
        >
          <NoddiIcon name='ChevronDown' size='xSmall' />
        </Button>
      </div>
    </div>
  );
};
